var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInboxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 79v10l15-10h40V34H20v45h5z",
    fill: "#F4F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 9C72.835 9 65 16.835 65 26.5c0 2.696.66 5.22 1.749 7.5L80 43.748c.823.119 1.644.252 2.5.252 9.665 0 17.5-7.835 17.5-17.5S92.165 9 82.5 9z",
    fill: "#E1EAF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.748 34a17.426 17.426 0 0013.251 9.748V34H66.748z",
    fill: "#D5E0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 16.5V19c0 1.38-1.12 2.5-2.5 2.5H75v5h2.5c.88 0 1.714-.18 2.5-.46V36.5h5v-20h-5z",
    fill: "#F4F7FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 64h40v5H30v-5zM30 54h40v5H30v-5zM30 44h40v5H30v-5z",
    fill: "#E1EAF8"
  })));
}

export default __webpack_public_path__ + "./fonts/inbox-icon.11cc8dbec27dd2843304a0effd81c1ea.svg";
export { SvgInboxIcon as ReactComponent };